angular.module('bribac.components.sampleChartModal', [
    'bribac.translations',
    'chart.js',
    "bribac.components.whenLoaded",
    'bribac.services.api',
    'bribac.values'
])
    .component('sampleChartModal', {
        templateUrl: 'sample-chart-modal-component.html',
        controller: 'SampleChartModalComponentCtrl',
        bindings: {
            close: '&',
            dismiss: '&',
            modalInstance: '<',
            resolve: '<'
        }
    })
    .controller('SampleChartModalComponentCtrl', ['$translate', '$scope', 'api', 'state', function (
        $translate,
        $scope,
        api,
        state
    ) {
        var $ctrl = this;
        $scope.showMood = true
        $ctrl.unit = state.currentAgent.organization.bacUnit
        $ctrl.displayUnit = ' ' + $translate.instant('bacUnits.short.' + $ctrl.unit, null, "", "");

        $scope.chosenDateFrom = new Date();
        $scope.chosenDateTo = new Date();
        $scope.type = 'MOOD';

        $scope.opened = {
            chosenDateFrom: false,
            chosenDateTo: false
        };

        $scope.open = function ($event, picker) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.opened[picker] = true;
        };

        $scope.$watch('chosenDateFrom', function (newval) {
            if (newval > $scope.chosenDateTo) {
                $scope.chosenDateTo = newval;
            }
        });

        $scope.$watch('chosenDateTo', function (newval) {
            if (newval < $scope.chosenDateFrom) {
                $scope.chosenDateFrom = newval;
            }
        });

        $scope.$watch('type', function (newval) {
            if (newval < $scope.type) {
                $scope.type = newval;
            }
        });

        $scope.dateOptionsFrom = {
            formatYear: 'yy',
            startingDay: 1,
            customClass: getBorderRangeClass(),
        };

        $scope.dateOptionsTo = {
            formatYear: 'yy',
            startingDay: 1,
            customClass: getBorderRangeClass()
        };

        $scope.clear = function () {
            $scope.chosenDateFrom = new Date();
            $scope.chosenDateTo = new Date();
        };
        $scope.lastWeek = quickDateSelection(7);
        $scope.lastMonth = quickDateSelection(30);
        $scope.lastSixMonth = quickDateSelection(180);
        $scope.lastYear = quickDateSelection(360);
        $scope.mood = changeType('MOOD', true);
        $scope.failedFrs = changeType('FAILED_FRS', false);
        $scope.failedAlcohol = changeType('FAILED_ALCOHOL', false);
        $scope.missedSchedule = changeType('MISSED_SCHEDULE', false);

        $ctrl.$onInit = function () {
            if ($ctrl.resolve) {
                $scope.subjectId = $scope.subjectId ? $scope.subjectId : $ctrl.resolve.subject.id;
                $ctrl.dataPromise = api.getAlcoholSamplesChartData($ctrl.resolve.subject.id).then(
                    function success(request) {
                        $scope.alcoholSamples = request.data
                        setup_chart({})
                    }).catch(function (err) {
                    console.log("rejected with", err);
                })

            }

        };

        /**
         * Callback function called when a day from the calendar is chosen. It sorts
         * the array of samples by the `dateCreated` field and filters the samples only
         * for the selected period.
         * @param selectedDateFrom
         * @param selectedDateTo
         */
        $scope.dateChosen = function (selectedDateFrom, selectedDateTo) {
            if ($scope.subjectId) {
                $ctrl.dataPromise = api.getAlcoholSamplesChartDataFromTo($scope.subjectId,
                    toJSONLocal(selectedDateFrom),
                    toJSONLocal(selectedDateTo),
                    $scope.type).then(
                    function success(request) {
                        var chartData = request.data;
                        setup_chart(chartData);
                    }).catch(function (err) {
                    console.log("rejected with", err);
                })
            }
        }

        /**
         * Function that adding custom classes into the date based on passing an object
         * with date and current mode properties.
         */
        function getBorderRangeClass() {
            return function (data) {
                var date = data.date;
                var mode = data.mode;
                if (mode === 'day') {
                    var dayToCheck = new Date(date).setHours(0, 0, 0, 0);
                    var startDay = new Date($scope.chosenDateFrom).setHours(0, 0, 0, 0);
                    var endDay = new Date($scope.chosenDateTo).setHours(0, 0, 0, 0);

                    if (dayToCheck === startDay || dayToCheck === endDay) {
                        return 'border';
                    }
                    if (dayToCheck >= startDay && dayToCheck < endDay) {
                        return 'range';
                    }
                    if ($scope.alcoholSamples) {
                        for (var i = 0; i < $scope.alcoholSamples.containedDates.length; i++) {
                            var currentDay = new Date($scope.alcoholSamples.containedDates[i]).setHours(0, 0, 0, 0);
                            if (dayToCheck == currentDay) {
                                return "sample"
                            }
                        }
                    }
                }
                return '';
            };
        }

        function quickDateSelection(days) {
            return function () {
                $scope.chosenDateFrom = subDaysFromDate(days);
                $scope.chosenDateTo = new Date();
                $scope.dateChosen($scope.chosenDateFrom, $scope.chosenDateTo);
            };
        }

        function changeType(type, showMood) {
            return function () {
                $scope.type = type;
                $scope.showMood = showMood;
                $scope.dateChosen($scope.chosenDateFrom, $scope.chosenDateTo);
                $scope.$apply()
            }
        }

        function subDaysFromDate(days) {
            var lastWeek = new Date();
            lastWeek.setDate(lastWeek.getDate() - days);
            return lastWeek;
        }

        /**
         * According to the given `chartData` setups the line chart. It suppose the object `chartData`
         * to contain two arrays: `mergedTimes` containing the hours of a day for the x axis in a format:
         * ["12:15", "14:22"] and `mergedValues` as an array containing the samples amount in the format:
         * [0.1255, 0.963, etc.]
         * @param chartData
         */
        function setup_chart(chartData) {
            $scope.labels = ['12:00'];
            if (!isEmpty(chartData.times)) {
                $scope.labels = chartData.times;
            }
            $scope.series = ['Samples', "Optional samples"];
            $scope.data = [
                [0]
            ];
            if (!isEmpty(chartData.values)) {
                var valuesInUnit = chartData.values.map(function (value) {
                    return value[$ctrl.unit]
                });
                $scope.data = [
                    valuesInUnit
                ]
            }
            $scope.onClick = function (points, evt) {
            };
            $scope.datasetOverride = [{
                yAxisID: 'y-axis-1',
                pointBackgroundColor: chartData.pointColors,
                pointRadius: chartData.pointRadiates
            }];
            $scope.options = {
                tooltips: {
                    callbacks: {
                        label: function (item) {
                            if (item.yLabel === 0) {
                                return '0.00' + $ctrl.displayUnit;
                            }
                            return item.yLabel + $ctrl.displayUnit;
                        }
                    },
                },
                scales: {
                    yAxes: [
                        {
                            id: 'y-axis-1',
                            type: 'linear',
                            display: true,
                            position: 'left',
                            ticks: {
                                callback: function (value, index, values) {
                                    return value.toFixed(2) + $ctrl.displayUnit;
                                }
                            }
                        }
                    ]
                }
            };
        }
    }
    ])
    .directive('drawCircle', function () {
        return {
            scope: {
                x: '@x',
                y: '@y',
                color: '@color',
                radius: '@radius'
            },
            link: function (scope, element, attrs) {
                var x = parseInt(scope.x);
                var y = parseInt(scope.y);
                var radius = parseInt(scope.radius);
                var canvas = element.parent();
                var ctx = canvas[0].getContext("2d");
                ctx.beginPath();
                ctx.arc(x, y, radius, 0, 2 * Math.PI, false);
                ctx.lineWidth = 0.2;
                ctx.fillStyle = scope.color;
                ctx.stroke();
                ctx.fill();
            }
        }
    })
    .directive('drawCircleCenter', function () {
        return {
            scope: {
                color: '@color',
                radius: '@radius'
            },
            link: function (scope, element, attrs) {
                var radius = parseInt(scope.radius);
                var canvas = element.parent();
                var ctx = canvas[0].getContext("2d");
                var x = canvas[0].width / 2;
                var y = canvas[0].height / 2;
                ctx.beginPath();
                ctx.arc(x, y, radius, 0, 2 * Math.PI, false);
                ctx.lineWidth = 0.2;
                ctx.fillStyle = scope.color;
                ctx.stroke();
                ctx.fill();
            }
        }
    });

function compareStringDates(sampleA, sampleB) {
    var comparison = 0;
    if (sampleA && sampleB) {
        if (new Date(sampleA['dateCreated']) > new Date(sampleB['dateCreated'])) {
            comparison = 1;
        } else if (new Date(sampleA['dateCreated']) < new Date(sampleB['dateCreated'])) {
            comparison = -1;
        }
    }
    return comparison;
}

function isEmpty(value) {
    return !value ||
        (Array.isArray(value) && !value.length) ||
        (typeof value === 'object' && !Object.keys(value).length);
}

function toJSONLocal(date) {
    return date ? date.toISOString().slice(0, 10) : "";
}